var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAltImagery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5567 5.39114L18.3968 3.0704L19.5567 0.75H13.5215V5.39114H16.136H19.5567Z",
    fill: "#9599A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.125 18.2L20.2493 12.6763L18.5497 14.6016L21.2659 18.3255L20.4983 18.8854L18.0356 15.5283L12.5287 8.02098V0.750885H11.5192V8.02098L6.01231 15.5283L0 23.7244H10.4987H12.024H20.2493H24.0479H30L25.125 18.2Z",
    fill: "#9599A6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAltImagery);
export default __webpack_public_path__ + "static/media/altImagery.e096867bccf6eb912d9f68406d98e36e.svg";
export { ForwardRef as ReactComponent };